import { functions } from "lodash";

export default {
    getIntervalsSettings: function(state) {
        return state.intervalsSettings;
    },
    getSavedSettings: function(state) {
        return state.savedSettings;
    },
    getCurrency: function(state) {
        return state.currency;
    },
    getDate: function(state) {
        return state.date;
    },
    getSelectedPayments: function(state) {
        return state.selected;
    },
    isSelectedDocument: (state) => (documentId) =>{
        return state.selected.includes(documentId);
    }
};